import { BaseAPI } from './BaseAPI.js'
import { OrganizationDisposition } from '../types/index.js'

export default class OrganizationDispositionAPI extends BaseAPI<OrganizationDisposition> {
  override get resource(): string {
    return '/organizationDispositions'
  }
}
